export default "__VITE_ASSET__5529811a__"